export interface ProductionShortcutTemplateArtwork {
  main_picture: string;
  screenshots: string[];
}

export const productionShortcutTemplateArtwork: Record<
  string,
  ProductionShortcutTemplateArtwork
> = {
  '4game': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/4game/4game.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/4game/4game-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/4game/4game-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/4game/4game-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/4game/4game-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/4game/4game-05.jpg',
    ],
  },
  '7 Days to Die': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/7-days-to-die/7-days-to-die.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/7-days-to-die/7-days-to-die-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/7-days-to-die/7-days-to-die-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/7-days-to-die/7-days-to-die-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/7-days-to-die/7-days-to-die-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/7-days-to-die/7-days-to-die-05.jpg',
    ],
  },
  'Albion Online': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/albion-online/albion-online.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/albion-online/albion-online-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/albion-online/albion-online-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/albion-online/albion-online-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/albion-online/albion-online-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/albion-online/albion-online-05.jpg',
    ],
  },
  'Amazing RP': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/amazing-rp/amazing-rp.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/amazing-rp/amazing-rp-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/amazing-rp/amazing-rp-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/amazing-rp/amazing-rp-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/amazing-rp/amazing-rp-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/amazing-rp/amazing-rp-05.jpg',
    ],
  },
  'Among Us': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/among-us/among-us.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/among-us/among-us-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/among-us/among-us-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/among-us/among-us-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/among-us/among-us-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/among-us/among-us-05.jpg',
    ],
  },
  'Apex Legends': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/apex-legends/apex-legends.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/apex-legends/apex-legends-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/apex-legends/apex-legends-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/apex-legends/apex-legends-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/apex-legends/apex-legends-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/apex-legends/apex-legends-05.jpg',
    ],
  },
  'ARC Raiders': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/arc-raiders/arc-raiders.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/arc-raiders/arc-raiders-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/arc-raiders/arc-raiders-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/arc-raiders/arc-raiders-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/arc-raiders/arc-raiders-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/arc-raiders/arc-raiders-05.jpg',
    ],
  },
  'Arena Breakout': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/arena-breakout/arena-breakout.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/arena-breakout/arena-breakout-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/arena-breakout/arena-breakout-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/arena-breakout/arena-breakout-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/arena-breakout/arena-breakout-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/arena-breakout/arena-breakout-05.jpg',
    ],
  },
  'Arena Breakout: Infinite': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/arena-breakout-infinite/arena-breakout-infinite.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/arena-breakout-infinite/arena-breakout-infinite-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/arena-breakout-infinite/arena-breakout-infinite-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/arena-breakout-infinite/arena-breakout-infinite-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/arena-breakout-infinite/arena-breakout-infinite-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/arena-breakout-infinite/arena-breakout-infinite-05.jpg',
    ],
  },
  'Arizona RP': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/arizona-rp/arizona-rp.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/arizona-rp/arizona-rp-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/arizona-rp/arizona-rp-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/arizona-rp/arizona-rp-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/arizona-rp/arizona-rp-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/arizona-rp/arizona-rp-05.jpg',
    ],
  },
  'ARMA 3': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/arma-3/arma-3.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/arma-3/arma-3-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/arma-3/arma-3-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/arma-3/arma-3-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/arma-3/arma-3-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/arma-3/arma-3-05.jpg',
    ],
  },
  'Assetto Corsa': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/assetto-corsa/assetto-corsa.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/assetto-corsa/assetto-corsa-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/assetto-corsa/assetto-corsa-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/assetto-corsa/assetto-corsa-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/assetto-corsa/assetto-corsa-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/assetto-corsa/assetto-corsa-05.jpg',
    ],
  },
  'Atomic Heart': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/atomic-heart/atomic-heart.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/atomic-heart/atomic-heart-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/atomic-heart/atomic-heart-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/atomic-heart/atomic-heart-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/atomic-heart/atomic-heart-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/atomic-heart/atomic-heart-05.jpg',
    ],
  },
  'Baldur’s Gate 3': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/baldurs-gate-3/baldurs-gate-3.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/baldurs-gate-3/baldurs-gate-3-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/baldurs-gate-3/baldurs-gate-3-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/baldurs-gate-3/baldurs-gate-3-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/baldurs-gate-3/baldurs-gate-3-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/baldurs-gate-3/baldurs-gate-3-05.jpg',
    ],
  },
  'Battle.net': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/battlenet/battlenet.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/battlenet/battlenet-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/battlenet/battlenet-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/battlenet/battlenet-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/battlenet/battlenet-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/battlenet/battlenet-05.jpg',
    ],
  },
  'Battlefield 1': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/battlefield-1/battlefield-1.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/battlefield-1/battlefield-1-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/battlefield-1/battlefield-1-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/battlefield-1/battlefield-1-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/battlefield-1/battlefield-1-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/battlefield-1/battlefield-1-05.jpg',
    ],
  },
  'Battlefield 2042': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/battlefield-2042/battlefield-2042.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/battlefield-2042/battlefield-2042-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/battlefield-2042/battlefield-2042-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/battlefield-2042/battlefield-2042-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/battlefield-2042/battlefield-2042-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/battlefield-2042/battlefield-2042-05.jpg',
    ],
  },
  'Battlefield 4': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/battlefield-4/battlefield-4.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/battlefield-4/battlefield-4-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/battlefield-4/battlefield-4-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/battlefield-4/battlefield-4-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/battlefield-4/battlefield-4-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/battlefield-4/battlefield-4-05.jpg',
    ],
  },
  'Battlefield 6': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/battlefield-6/battlefield-6.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/battlefield-6/battlefield-6-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/battlefield-6/battlefield-6-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/battlefield-6/battlefield-6-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/battlefield-6/battlefield-6-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/battlefield-6/battlefield-6-05.jpg',
    ],
  },
  'Battlefield V': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/battlefield-v/battlefield-v.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/battlefield-v/battlefield-v-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/battlefield-v/battlefield-v-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/battlefield-v/battlefield-v-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/battlefield-v/battlefield-v-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/battlefield-v/battlefield-v-05.jpg',
    ],
  },
  'BeamNG.drive': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/beamngdrive/beamngdrive.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/beamngdrive/beamngdrive-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/beamngdrive/beamngdrive-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/beamngdrive/beamngdrive-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/beamngdrive/beamngdrive-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/beamngdrive/beamngdrive-05.jpg',
    ],
  },
  'Black Desert': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/black-desert/black-desert.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/black-desert/black-desert-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/black-desert/black-desert-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/black-desert/black-desert-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/black-desert/black-desert-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/black-desert/black-desert-05.jpg',
    ],
  },
  BlueStacks: {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/bluestacks/bluestacks.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/bluestacks/bluestacks-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/bluestacks/bluestacks-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/bluestacks/bluestacks-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/bluestacks/bluestacks-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/bluestacks/bluestacks-05.jpg',
    ],
  },
  Blur: {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/blur/blur.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/blur/blur-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/blur/blur-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/blur/blur-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/blur/blur-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/blur/blur-05.jpg',
    ],
  },
  Bodycam: {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/bodycam/bodycam.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/bodycam/bodycam-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/bodycam/bodycam-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/bodycam/bodycam-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/bodycam/bodycam-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/bodycam/bodycam-05.jpg',
    ],
  },
  Brawlhalla: {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/brawlhalla/brawlhalla.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/brawlhalla/brawlhalla-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/brawlhalla/brawlhalla-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/brawlhalla/brawlhalla-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/brawlhalla/brawlhalla-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/brawlhalla/brawlhalla-05.jpg',
    ],
  },
  'Call of Duty': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/call-of-duty/call-of-duty.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/call-of-duty/call-of-duty-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/call-of-duty/call-of-duty-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/call-of-duty/call-of-duty-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/call-of-duty/call-of-duty-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/call-of-duty/call-of-duty-05.jpg',
    ],
  },
  'Call of Duty 4: Modern Warfare': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/call-of-duty-4-modern-warfare/call-of-duty-4-modern-warfare.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/call-of-duty-4-modern-warfare/call-of-duty-4-modern-warfare-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/call-of-duty-4-modern-warfare/call-of-duty-4-modern-warfare-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/call-of-duty-4-modern-warfare/call-of-duty-4-modern-warfare-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/call-of-duty-4-modern-warfare/call-of-duty-4-modern-warfare-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/call-of-duty-4-modern-warfare/call-of-duty-4-modern-warfare-05.jpg',
    ],
  },
  'Call of Duty: Warzone': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/call-of-duty-warzone/call-of-duty-warzone.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/call-of-duty-warzone/call-of-duty-warzone-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/call-of-duty-warzone/call-of-duty-warzone-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/call-of-duty-warzone/call-of-duty-warzone-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/call-of-duty-warzone/call-of-duty-warzone-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/call-of-duty-warzone/call-of-duty-warzone-05.jpg',
    ],
  },
  'City Car Driving': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/city-car-driving/city-car-driving.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/city-car-driving/city-car-driving-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/city-car-driving/city-car-driving-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/city-car-driving/city-car-driving-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/city-car-driving/city-car-driving-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/city-car-driving/city-car-driving-05.jpg',
    ],
  },
  'Command & Conquer: Generals': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/command-and-conquer-generals/command-and-conquer-generals.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/command-and-conquer-generals/command-and-conquer-generals-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/command-and-conquer-generals/command-and-conquer-generals-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/command-and-conquer-generals/command-and-conquer-generals-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/command-and-conquer-generals/command-and-conquer-generals-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/command-and-conquer-generals/command-and-conquer-generals-05.jpg',
    ],
  },
  'Command & Conquer: Generals – Zero Hour': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/command-and-conquer-generals-zero-hour/command-and-conquer-generals-zero-hour.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/command-and-conquer-generals-zero-hour/command-and-conquer-generals-zero-hour-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/command-and-conquer-generals-zero-hour/command-and-conquer-generals-zero-hour-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/command-and-conquer-generals-zero-hour/command-and-conquer-generals-zero-hour-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/command-and-conquer-generals-zero-hour/command-and-conquer-generals-zero-hour-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/command-and-conquer-generals-zero-hour/command-and-conquer-generals-zero-hour-05.jpg',
    ],
  },
  'Command & Conquer: Red Alert 2': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/command-and-conquer-red-alert-2/command-and-conquer-red-alert-2.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/command-and-conquer-red-alert-2/command-and-conquer-red-alert-2-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/command-and-conquer-red-alert-2/command-and-conquer-red-alert-2-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/command-and-conquer-red-alert-2/command-and-conquer-red-alert-2-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/command-and-conquer-red-alert-2/command-and-conquer-red-alert-2-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/command-and-conquer-red-alert-2/command-and-conquer-red-alert-2-05.jpg',
    ],
  },
  'Content Warning': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/content-warning/content-warning.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/content-warning/content-warning-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/content-warning/content-warning-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/content-warning/content-warning-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/content-warning/content-warning-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/content-warning/content-warning-05.jpg',
    ],
  },
  'Counter-Strike': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/counter-strike/counter-strike.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/counter-strike/counter-strike-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/counter-strike/counter-strike-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/counter-strike/counter-strike-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/counter-strike/counter-strike-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/counter-strike/counter-strike-05.jpg',
    ],
  },
  'Counter-Strike 1.6': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/counter-strike-16/counter-strike-16.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/counter-strike-16/counter-strike-16-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/counter-strike-16/counter-strike-16-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/counter-strike-16/counter-strike-16-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/counter-strike-16/counter-strike-16-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/counter-strike-16/counter-strike-16-05.jpg',
    ],
  },
  'Counter-Strike 2': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/counter-strike-2/counter-strike-2.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/counter-strike-2/counter-strike-2-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/counter-strike-2/counter-strike-2-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/counter-strike-2/counter-strike-2-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/counter-strike-2/counter-strike-2-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/counter-strike-2/counter-strike-2-05.jpg',
    ],
  },
  'Counter-Strike: Source': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/counter-strike-source/counter-strike-source.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/counter-strike-source/counter-strike-source-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/counter-strike-source/counter-strike-source-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/counter-strike-source/counter-strike-source-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/counter-strike-source/counter-strike-source-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/counter-strike-source/counter-strike-source-05.jpg',
    ],
  },
  Crossout: {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/crossout/crossout.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/crossout/crossout-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/crossout/crossout-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/crossout/crossout-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/crossout/crossout-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/crossout/crossout_32.jpg',
    ],
  },
  'Cyberpunk 2077': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/cyberpunk-2077/cyberpunk-2077.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/cyberpunk-2077/cyberpunk-2077-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/cyberpunk-2077/cyberpunk-2077-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/cyberpunk-2077/cyberpunk-2077-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/cyberpunk-2077/cyberpunk-2077-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/cyberpunk-2077/cyberpunk-2077-05.jpg',
    ],
  },
  'Days Gone': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/days-gone/days-gone.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/days-gone/days-gone-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/days-gone/days-gone-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/days-gone/days-gone-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/days-gone/days-gone-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/days-gone/days-gone-05.jpg',
    ],
  },
  DayZ: {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/dayz/dayz.png',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/dayz/dayz-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/dayz/dayz-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/dayz/dayz-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/dayz/dayz-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/dayz/dayz-05.jpg',
    ],
  },
  'DayZ Launcher': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/dayz-launcher/dayz-launcher.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/dayz-launcher/dayz-launcher-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/dayz-launcher/dayz-launcher-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/dayz-launcher/dayz-launcher-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/dayz-launcher/dayz-launcher-04.jpg',
    ],
  },
  'Dead by Daylight': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/dead-by-daylight/dead-by-daylight.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/dead-by-daylight/dead-by-daylight-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/dead-by-daylight/dead-by-daylight-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/dead-by-daylight/dead-by-daylight-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/dead-by-daylight/dead-by-daylight-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/dead-by-daylight/dead-by-daylight-05.jpg',
    ],
  },
  Deadlock: {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/deadlock/deadlock.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/deadlock/deadlock-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/deadlock/deadlock-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/deadlock/deadlock-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/deadlock/deadlock-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/deadlock/deadlock-05.jpg',
    ],
  },
  Deceit: {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/deceit/deceit.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/deceit/deceit-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/deceit/deceit-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/deceit/deceit-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/deceit/deceit-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/deceit/deceit-05.jpg',
    ],
  },
  'Deep Rock Galactic': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/deep-rock-galactic/deep-rock-galactic.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/deep-rock-galactic/deep-rock-galactic-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/deep-rock-galactic/deep-rock-galactic-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/deep-rock-galactic/deep-rock-galactic-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/deep-rock-galactic/deep-rock-galactic-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/deep-rock-galactic/deep-rock-galactic-05.jpg',
    ],
  },
  'Delta Force': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/delta-force/delta-force.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/delta-force/delta-force-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/delta-force/delta-force-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/delta-force/delta-force-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/delta-force/delta-force-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/delta-force/delta-force-05.jpg',
    ],
  },
  'Destiny 2': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/destiny-2/destiny-2.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/destiny-2/destiny-2-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/destiny-2/destiny-2-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/destiny-2/destiny-2-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/destiny-2/destiny-2-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/destiny-2/destiny-2-05.jpg',
    ],
  },
  Discord: {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/discord/discord.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/discord/discord-01.png',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/discord/discord-02.png',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/discord/discord-03.png',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/discord/discord-04.png',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/discord/discord-05.png',
    ],
  },
  'DOOM Eternal': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/doom-eternal/doom-eternal.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/doom-eternal/doom-eternal-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/doom-eternal/doom-eternal-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/doom-eternal/doom-eternal-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/doom-eternal/doom-eternal-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/doom-eternal/doom-eternal-05.jpg',
    ],
  },
  'Dota 2': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/dota-2/dota-2.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/dota-2/dota-2-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/dota-2/dota-2-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/dota-2/dota-2-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/dota-2/dota-2-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/dota-2/dota-2-05.jpg',
    ],
  },
  'Drive Beyond Horizons': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/drive-beyond-horizons/drive-beyond-horizons.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/drive-beyond-horizons/drive-beyond-horizons-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/drive-beyond-horizons/drive-beyond-horizons-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/drive-beyond-horizons/drive-beyond-horizons-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/drive-beyond-horizons/drive-beyond-horizons-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/drive-beyond-horizons/drive-beyond-horizons-05.jpg',
    ],
  },
  'Dying Light': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/dying-light/dying-light.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/dying-light/dying-light-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/dying-light/dying-light-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/dying-light/dying-light-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/dying-light/dying-light-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/dying-light/dying-light-05.jpg',
    ],
  },
  'Dying Light 2': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/dying-light-2/dying-light-2.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/dying-light-2/dying-light-2-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/dying-light-2/dying-light-2-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/dying-light-2/dying-light-2-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/dying-light-2/dying-light-2-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/dying-light-2/dying-light-2-05.jpg',
    ],
  },
  'Elden Ring': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/elden-ring/elden-ring.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/elden-ring/elden-ring-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/elden-ring/elden-ring-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/elden-ring/elden-ring-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/elden-ring/elden-ring-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/elden-ring/elden-ring-05.jpg',
    ],
  },
  Enlisted: {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/enlisted/enlisted.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/enlisted/enlisted-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/enlisted/enlisted-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/enlisted/enlisted-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/enlisted/enlisted-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/enlisted/enlisted-05.jpg',
    ],
  },
  'Epic Games Launcher': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/epic-games-launcher/epic-games-launcher.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/epic-games-launcher/epic-games-launcher-01.png',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/epic-games-launcher/epic-games-launcher-02.png',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/epic-games-launcher/epic-games-launcher-03.png',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/epic-games-launcher/epic-games-launcher-04.png',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/epic-games-launcher/epic-games-launcher-05.png',
    ],
  },
  'Escape from Tarkov': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/escape-from-tarkov/escape-from-tarkov.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/escape-from-tarkov/escape-from-tarkov-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/escape-from-tarkov/escape-from-tarkov-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/escape-from-tarkov/escape-from-tarkov-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/escape-from-tarkov/escape-from-tarkov-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/escape-from-tarkov/escape-from-tarkov-05.jpg',
    ],
  },
  'Euro Truck Simulator 2': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/euro-truck-simulator-2/euro-truck-simulator-2.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/euro-truck-simulator-2/euro-truck-simulator-2-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/euro-truck-simulator-2/euro-truck-simulator-2-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/euro-truck-simulator-2/euro-truck-simulator-2-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/euro-truck-simulator-2/euro-truck-simulator-2-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/euro-truck-simulator-2/euro-truck-simulator-2-05.jpg',
    ],
  },
  FACEIT: {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/faceit/faceit.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/faceit/faceit-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/faceit/faceit-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/faceit/faceit-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/faceit/faceit-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/faceit/faceit-05.jpg',
    ],
  },
  'Fall Guys': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/fall-guys/fall-guys.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/fall-guys/fall-guys-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/fall-guys/fall-guys-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/fall-guys/fall-guys-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/fall-guys/fall-guys-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/fall-guys/fall-guys-05.jpg',
    ],
  },
  'Fallout 4': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/fallout-4/fallout-4.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/fallout-4/fallout-4-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/fallout-4/fallout-4-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/fallout-4/fallout-4-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/fallout-4/fallout-4-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/fallout-4/fallout-4-05.jpg',
    ],
  },
  'Far Cry 3': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/far-cry-3/far-cry-3.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/far-cry-3/far-cry-3-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/far-cry-3/far-cry-3-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/far-cry-3/far-cry-3-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/far-cry-3/far-cry-3-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/far-cry-3/far-cry-3-05.jpg',
    ],
  },
  'Far Cry 5': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/far-cry-5/far-cry-5.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/far-cry-5/far-cry-5-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/far-cry-5/far-cry-5-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/far-cry-5/far-cry-5-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/far-cry-5/far-cry-5-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/far-cry-5/far-cry-5-05.jpg',
    ],
  },
  'Far Cry 6': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/far-cry-6/far-cry-6.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/far-cry-6/far-cry-6-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/far-cry-6/far-cry-6-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/far-cry-6/far-cry-6-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/far-cry-6/far-cry-6-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/far-cry-6/far-cry-6-05.jpg',
    ],
  },
  'FlatOut 2': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/flatout-2/flatout-2.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/flatout-2/flatout-2-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/flatout-2/flatout-2-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/flatout-2/flatout-2-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/flatout-2/flatout-2-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/flatout-2/flatout-2-05.jpg',
    ],
  },
  'Forza Horizon 4': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/forza-horizon-4/forza-horizon-4.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/forza-horizon-4/forza-horizon-4-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/forza-horizon-4/forza-horizon-4-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/forza-horizon-4/forza-horizon-4-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/forza-horizon-4/forza-horizon-4-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/forza-horizon-4/forza-horizon-4-05.jpg',
    ],
  },
  'Forza Horizon 5': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/forza-horizon-5/forza-horizon-5.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/forza-horizon-5/forza-horizon-5-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/forza-horizon-5/forza-horizon-5-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/forza-horizon-5/forza-horizon-5-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/forza-horizon-5/forza-horizon-5-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/forza-horizon-5/forza-horizon-5-05.jpg',
    ],
  },
  FragPunk: {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/fragpunk/fragpunk.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/fragpunk/fragpunk-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/fragpunk/fragpunk-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/fragpunk/fragpunk-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/fragpunk/fragpunk-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/fragpunk/fragpunk-05.jpg',
    ],
  },
  'Garry’s Mod': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/garrys-mod/garrys-mod.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/garrys-mod/garrys-mod-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/garrys-mod/garrys-mod-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/garrys-mod/garrys-mod-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/garrys-mod/garrys-mod-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/garrys-mod/garrys-mod-05.jpg',
    ],
  },
  'Genshin Impact': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/genshin-impact/genshin-impact.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/genshin-impact/genshin-impact-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/genshin-impact/genshin-impact-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/genshin-impact/genshin-impact-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/genshin-impact/genshin-impact-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/genshin-impact/genshin-impact-05.jpg',
    ],
  },
  'Geometry Dash': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/geometry-dash/geometry-dash.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/geometry-dash/geometry-dash-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/geometry-dash/geometry-dash-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/geometry-dash/geometry-dash-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/geometry-dash/geometry-dash-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/geometry-dash/geometry-dash-05.jpg',
    ],
  },
  'Ghost of Tsushima Director’s Cut': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/ghost-of-tsushima-directors-cut/ghost-of-tsushima-directors-cut.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/ghost-of-tsushima-directors-cut/ghost-of-tsushima-directors-cut-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/ghost-of-tsushima-directors-cut/ghost-of-tsushima-directors-cut-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/ghost-of-tsushima-directors-cut/ghost-of-tsushima-directors-cut-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/ghost-of-tsushima-directors-cut/ghost-of-tsushima-directors-cut-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/ghost-of-tsushima-directors-cut/ghost-of-tsushima-directors-cut-05.jpg',
    ],
  },
  'God of War': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/god-of-war/god-of-war.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/god-of-war/god-of-war-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/god-of-war/god-of-war-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/god-of-war/god-of-war-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/god-of-war/god-of-war-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/god-of-war/god-of-war-05.jpg',
    ],
  },
  'Grand Theft Auto V': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/grand-theft-auto-v/grand-theft-auto-v.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/grand-theft-auto-v/grand-theft-auto-v-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/grand-theft-auto-v/grand-theft-auto-v-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/grand-theft-auto-v/grand-theft-auto-v-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/grand-theft-auto-v/grand-theft-auto-v-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/grand-theft-auto-v/grand-theft-auto-v-05.jpg',
    ],
  },
  'GTA 5 RP': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/gta-5-rp/gta-5-rp.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/gta-5-rp/gta-5-rp-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/gta-5-rp/gta-5-rp-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/gta-5-rp/gta-5-rp-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/gta-5-rp/gta-5-rp-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/gta-5-rp/gta-5-rp-05.jpg',
    ],
  },
  'Half-Life': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/half-life/half-life.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/half-life/half-life-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/half-life/half-life-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/half-life/half-life-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/half-life/half-life-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/half-life/half-life-05.jpg',
    ],
  },
  Hearthstone: {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/hearthstone/heartstone.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/hearthstone/hearthstone-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/hearthstone/hearthstone-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/hearthstone/hearthstone-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/hearthstone/hearthstone-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/hearthstone/hearthstone-05.jpg',
    ],
  },
  'HELLDIVERS 2': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/helldivers-2/helldivers-2.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/helldivers-2/helldivers-2-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/helldivers-2/helldivers-2-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/helldivers-2/helldivers-2-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/helldivers-2/helldivers-2-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/helldivers-2/helldivers-2-05.jpg',
    ],
  },
  'Heroes of the Storm': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/heroes-of-the-storm/heroes-of-the-storm.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/heroes-of-the-storm/heroes-of-the-storm-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/heroes-of-the-storm/heroes-of-the-storm-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/heroes-of-the-storm/heroes-of-the-storm-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/heroes-of-the-storm/heroes-of-the-storm-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/heroes-of-the-storm/heroes-of-the-storm-05.jpg',
    ],
  },
  'Hitman 3': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/hitman-3/hitman-3.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/hitman-3/hitman-3-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/hitman-3/hitman-3-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/hitman-3/hitman-3-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/hitman-3/hitman-3-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/hitman-3/hitman-3-05.jpg',
    ],
  },
  'Hogwarts Legacy': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/hogwarts-legacy/hogwarts-legacy.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/hogwarts-legacy/hogwarts-legacy-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/hogwarts-legacy/hogwarts-legacy-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/hogwarts-legacy/hogwarts-legacy-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/hogwarts-legacy/hogwarts-legacy-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/hogwarts-legacy/hogwarts-legacy-05.jpg',
    ],
  },
  'Honkai: Star Rail': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/honkai-star-rail/honkai-star-rail.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/honkai-star-rail/honkai-star-rail-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/honkai-star-rail/honkai-star-rail-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/honkai-star-rail/honkai-star-rail-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/honkai-star-rail/honkai-star-rail-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/honkai-star-rail/honkai-star-rail-05.jpg',
    ],
  },
  HoYoPlay: {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/hoyoplay/hoyoplay.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/hoyoplay/hoyoplay-01.png',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/hoyoplay/hoyoplay-02.png',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/hoyoplay/hoyoplay-03.png',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/hoyoplay/hoyoplay-04.png',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/hoyoplay/hoyoplay-05.png',
    ],
  },
  'Hunt: Showdown': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/hunt-showdown/hunt-showdown.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/hunt-showdown/hunt-showdown-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/hunt-showdown/hunt-showdown-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/hunt-showdown/hunt-showdown-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/hunt-showdown/hunt-showdown-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/hunt-showdown/hunt-showdown-05.jpg',
    ],
  },
  ICCup: {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/iccup/iccup.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/iccup/iccup-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/iccup/iccup-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/iccup/iccup-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/iccup/iccup-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/iccup/iccup-05.jpg',
    ],
  },
  inZOI: {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/inzoi/inzoi.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/inzoi/inzoi-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/inzoi/inzoi-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/inzoi/inzoi-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/inzoi/inzoi-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/inzoi/inzoi-05.jpg',
    ],
  },
  'It Takes Two': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/it-takes-two/it-takes-two.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/it-takes-two/it-takes-two-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/it-takes-two/it-takes-two-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/it-takes-two/it-takes-two-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/it-takes-two/it-takes-two-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/it-takes-two/it-takes-two-05.jpg',
    ],
  },
  'League of Legends': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/league-of-legends/league-of-legends.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/league-of-legends/league-of-legends-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/league-of-legends/league-of-legends-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/league-of-legends/league-of-legends-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/league-of-legends/league-of-legends-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/league-of-legends/league-of-legends-05.jpg',
    ],
  },
  'Left 4 Dead': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/left-4-dead/left-4-dead.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/left-4-dead/left-4-dead-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/left-4-dead/left-4-dead-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/left-4-dead/left-4-dead-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/left-4-dead/left-4-dead-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/left-4-dead/left-4-dead-05.jpg',
    ],
  },
  'Left 4 Dead 2': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/left-4-dead-2/left-4-dead-2.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/left-4-dead-2/left-4-dead-2-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/left-4-dead-2/left-4-dead-2-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/left-4-dead-2/left-4-dead-2-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/left-4-dead-2/left-4-dead-2-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/left-4-dead-2/left-4-dead-2-05.jpg',
    ],
  },
  'Lethal Company': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/lethal-company/lethal-company.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/lethal-company/lethal-company-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/lethal-company/lethal-company-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/lethal-company/lethal-company-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/lethal-company/lethal-company-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/lethal-company/lethal-company-05.jpg',
    ],
  },
  'Logitech G HUB': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/logitech-g-hub/logitech-g-hub.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/logitech-g-hub/logitech-g-hub-01.png',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/logitech-g-hub/logitech-g-hub-02.png',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/logitech-g-hub/logitech-g-hub-03.png',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/logitech-g-hub/logitech-g-hub-04.png',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/logitech-g-hub/logitech-g-hub-05.png',
    ],
  },
  'Lost Light': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/lost-light/lost-light.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/lost-light/lost-light-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/lost-light/lost-light-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/lost-light/lost-light-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/lost-light/lost-light-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/lost-light/lost-light-05.jpg',
    ],
  },
  'Mafia II': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/mafia-ii/mafia-ii.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/mafia-ii/mafia-ii-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/mafia-ii/mafia-ii-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/mafia-ii/mafia-ii-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/mafia-ii/mafia-ii-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/mafia-ii/mafia-ii-05.jpg',
    ],
  },
  'Majestic RP': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/majestic-rp/majestic-rp.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/majestic-rp/majestic-rp-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/majestic-rp/majestic-rp-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/majestic-rp/majestic-rp-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/majestic-rp/majestic-rp-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/majestic-rp/majestic-rp-05.jpg',
    ],
  },
  'Marvel Rivals': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/marvel-rivals/marvel-rivals.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/marvel-rivals/marvel-rivals-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/marvel-rivals/marvel-rivals-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/marvel-rivals/marvel-rivals-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/marvel-rivals/marvel-rivals-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/marvel-rivals/marvel-rivals-05.jpg',
    ],
  },
  'Metro 2033 Redux': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/metro-2033-redux/metro-2033-redux.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/metro-2033-redux/metro-2033-redux-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/metro-2033-redux/metro-2033-redux-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/metro-2033-redux/metro-2033-redux-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/metro-2033-redux/metro-2033-redux-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/metro-2033-redux/metro-2033-redux-05.jpg',
    ],
  },
  'Metro Exodus': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/metro-exodus/metro-exodus.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/metro-exodus/metro-exodus-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/metro-exodus/metro-exodus-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/metro-exodus/metro-exodus-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/metro-exodus/metro-exodus-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/metro-exodus/metro-exodus-05.jpg',
    ],
  },
  Minecraft: {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/minecraft/minecraft.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/minecraft/minecraft-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/minecraft/minecraft-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/minecraft/minecraft-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/minecraft/minecraft-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/minecraft/minecraft-05.jpg',
    ],
  },
  'Need for Speed Heat': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/need-for-speed-heat/need-for-speed-heat.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/need-for-speed-heat/need-for-speed-heat-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/need-for-speed-heat/need-for-speed-heat-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/need-for-speed-heat/need-for-speed-heat-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/need-for-speed-heat/need-for-speed-heat-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/need-for-speed-heat/need-for-speed-heat-05.jpg',
    ],
  },
  'Need for Speed Payback': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/need-for-speed-payback/need-for-speed-payback.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/need-for-speed-payback/need-for-speed-payback-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/need-for-speed-payback/need-for-speed-payback-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/need-for-speed-payback/need-for-speed-payback-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/need-for-speed-payback/need-for-speed-payback-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/need-for-speed-payback/need-for-speed-payback-05.jpg',
    ],
  },
  'Need for Speed: Most Wanted': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/need-for-speed-most-wanted/need-for-speed-most-wanted.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/need-for-speed-most-wanted/need-for-speed-most-wanted-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/need-for-speed-most-wanted/need-for-speed-most-wanted-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/need-for-speed-most-wanted/need-for-speed-most-wanted-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/need-for-speed-most-wanted/need-for-speed-most-wanted-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/need-for-speed-most-wanted/need-for-speed-most-wanted-05.jpg',
    ],
  },
  'Once Human': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/once-human/once-human.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/once-human/once-human-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/once-human/once-human-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/once-human/once-human-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/once-human/once-human-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/once-human/once-human-05.jpg',
    ],
  },
  'osu!': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/osu/osu.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/osu/osu-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/osu/osu-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/osu/osu-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/osu/osu-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/osu/osu-05.jpg',
    ],
  },
  'Overwatch 2': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/overwatch-2/overwatch.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/overwatch-2/overwatch-2-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/overwatch-2/overwatch-2-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/overwatch-2/overwatch-2-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/overwatch-2/overwatch-2-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/overwatch-2/overwatch-2-05.jpg',
    ],
  },
  Paladins: {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/paladins/paladins.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/paladins/paladins-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/paladins/paladins-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/paladins/paladins-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/paladins/paladins-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/paladins/paladins-05.jpg',
    ],
  },
  'Path of Exile': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/path-of-exile/path-of-exile.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/path-of-exile/path-of-exile-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/path-of-exile/path-of-exile-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/path-of-exile/path-of-exile-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/path-of-exile/path-of-exile-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/path-of-exile/path-of-exile-05.jpg',
    ],
  },
  'Path of Exile 2': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/path-of-exile-2/path-of-exile-2.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/path-of-exile-2/path-of-exile-2-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/path-of-exile-2/path-of-exile-2-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/path-of-exile-2/path-of-exile-2-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/path-of-exile-2/path-of-exile-2-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/path-of-exile-2/path-of-exile-2-05.jpg',
    ],
  },
  'Payday 2': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/payday-2/payday-2.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/payday-2/payday-2-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/payday-2/payday-2-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/payday-2/payday-2-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/payday-2/payday-2-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/payday-2/payday-2-05.jpg',
    ],
  },
  PEAK: {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/peak/peak.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/peak/peak-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/peak/peak-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/peak/peak-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/peak/peak-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/peak/peak-05.jpg',
    ],
  },
  Phasmophobia: {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/phasmophobia/phasmophobia.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/phasmophobia/phasmophobia-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/phasmophobia/phasmophobia-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/phasmophobia/phasmophobia-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/phasmophobia/phasmophobia-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/phasmophobia/phasmophobia-05.jpg',
    ],
  },
  'Portal 2': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/portal-2/portal-2.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/portal-2/portal-2-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/portal-2/portal-2-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/portal-2/portal-2-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/portal-2/portal-2-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/portal-2/portal-2-05.jpg',
    ],
  },
  'PUBG Mobile': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/pubg-mobile/pubg-mobile.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/pubg-mobile/pubg-mobile-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/pubg-mobile/pubg-mobile-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/pubg-mobile/pubg-mobile-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/pubg-mobile/pubg-mobile-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/pubg-mobile/pubg-mobile-05.jpg',
    ],
  },
  'PUBG: Battlegrounds': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/pubg-battlegrounds/pubg-battlegrounds.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/pubg-battlegrounds/pubg-battlegrounds-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/pubg-battlegrounds/pubg-battlegrounds-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/pubg-battlegrounds/pubg-battlegrounds-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/pubg-battlegrounds/pubg-battlegrounds-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/pubg-battlegrounds/pubg-battlegrounds-05.jpg',
    ],
  },
  'R.E.P.O.': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/repo/repo.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/repo/repo-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/repo/repo-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/repo/repo-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/repo/repo-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/repo/repo-05.jpg',
    ],
  },
  'Radmir RP': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/radmir-rp/radmir-rp.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/radmir-rp/radmar-rp-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/radmir-rp/radmar-rp-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/radmir-rp/radmar-rp-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/radmir-rp/radmar-rp-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/radmir-rp/radmar-rp-05.jpg',
    ],
  },
  Raft: {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/raft/raft.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/raft/raft-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/raft/raft-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/raft/raft-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/raft/raft-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/raft/raft-05.jpg',
    ],
  },
  'RAGE Multiplayer': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/rage-multiplayer/rage-multiplyer.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/rage-multiplayer/rage-multiplayer-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/rage-multiplayer/rage-multiplayer-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/rage-multiplayer/rage-multiplayer-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/rage-multiplayer/rage-multiplayer-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/rage-multiplayer/rage-multiplayer-05.jpg',
    ],
  },
  'Ready or Not': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/ready-or-not/ready-or-not.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/ready-or-not/ready-or-not-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/ready-or-not/ready-or-not-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/ready-or-not/ready-or-not-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/ready-or-not/ready-or-not-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/ready-or-not/ready-or-not-05.jpg',
    ],
  },
  'Red Dead Redemption 2': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/red-dead-redemption-2/red-dead-redemption-2.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/red-dead-redemption-2/red-dead-redemption-2-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/red-dead-redemption-2/red-dead-redemption-2-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/red-dead-redemption-2/red-dead-redemption-2-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/red-dead-redemption-2/red-dead-redemption-2-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/red-dead-redemption-2/red-dead-redemption-2-05.jpg',
    ],
  },
  'Riot Client': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/riot-client/riot-client.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/riot-client/riot-client-01.png',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/riot-client/riot-client-02.png',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/riot-client/riot-client-03.png',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/riot-client/riot-client-04.png',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/riot-client/riot-client-05.png',
    ],
  },
  Roblox: {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/roblox/roblox.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/roblox/roblox-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/roblox/roblox-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/roblox/roblox-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/roblox/roblox-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/roblox/roblox-05.jpg',
    ],
  },
  'Rocket League': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/rocket-league/rocket-league.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/rocket-league/rocket-league-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/rocket-league/rocket-league-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/rocket-league/rocket-league-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/rocket-league/rocket-league-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/rocket-league/rocket-league-05.jpg',
    ],
  },
  'Rockstar Games Launcher': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/rockstar-games-launcher/rockstar-games-launcher.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/rockstar-games-launcher/rockstar-games-launcher-01.png',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/rockstar-games-launcher/rockstar-games-launcher-02.png',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/rockstar-games-launcher/rockstar-games-launcher-03.png',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/rockstar-games-launcher/rockstar-games-launcher-04.png',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/rockstar-games-launcher/rockstar-games-launcher-05.png',
    ],
  },
  Rust: {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/rust/rust.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/rust/rust-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/rust/rust-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/rust/rust-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/rust/rust-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/rust/rust-05.jpg',
    ],
  },
  'S.T.A.L.K.E.R.': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/stalker/stalker.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/stalker/stalker-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/stalker/stalker-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/stalker/stalker-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/stalker/stalker-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/stalker/stalker-05.jpg',
    ],
  },
  'SCP: Secret Laboratory': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/scp-secret-laboratory/scp-secret-laboratory.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/scp-secret-laboratory/scp-secret-laboratory-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/scp-secret-laboratory/scp-secret-laboratory-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/scp-secret-laboratory/scp-secret-laboratory-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/scp-secret-laboratory/scp-secret-laboratory-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/scp-secret-laboratory/scp-secret-laboratory-05.jpg',
    ],
  },
  'Sea of Thieves': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/sea-of-thieves/sea-of-thieves.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/sea-of-thieves/sea-of-thieves-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/sea-of-thieves/sea-of-thieves-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/sea-of-thieves/sea-of-thieves-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/sea-of-thieves/sea-of-thieves-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/sea-of-thieves/sea-of-thieves-05.jpg',
    ],
  },
  'Sniper: Ghost Warrior 2': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/sniper-ghost-warrior-2/sniper-ghost-warrior-2.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/sniper-ghost-warrior-2/sniper-ghost-warrior-2-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/sniper-ghost-warrior-2/sniper-ghost-warrior-2-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/sniper-ghost-warrior-2/sniper-ghost-warrior-2-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/sniper-ghost-warrior-2/sniper-ghost-warrior-2-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/sniper-ghost-warrior-2/sniper-ghost-warrior-2-05.jpg',
    ],
  },
  'Sons of the Forest': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/sons-of-the-forest/sons-of-the-forest.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/sons-of-the-forest/sons-of-the-forest-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/sons-of-the-forest/sons-of-the-forest-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/sons-of-the-forest/sons-of-the-forest-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/sons-of-the-forest/sons-of-the-forest-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/sons-of-the-forest/sons-of-the-forest-05.jpg',
    ],
  },
  Squad: {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/squad/squad.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/squad/squad-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/squad/squad-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/squad/squad-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/squad/squad-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/squad/squad-05.jpg',
    ],
  },
  'STALCRAFT: X': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/stalcraft-x/stalcraft-x.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/stalcraft-x/stalcraft-x-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/stalcraft-x/stalcraft-x-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/stalcraft-x/stalcraft-x-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/stalcraft-x/stalcraft-x-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/stalcraft-x/stalcraft-x-05.jpg',
    ],
  },
  'StarCraft II': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/starcraft-ii/starcraft-ii.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/starcraft-ii/starcraft-ii-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/starcraft-ii/starcraft-ii-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/starcraft-ii/starcraft-ii-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/starcraft-ii/starcraft-ii-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/starcraft-ii/starcraft-ii-05.jpg',
    ],
  },
  Stray: {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/stray/stray.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/stray/stray-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/stray/stray-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/stray/stray-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/stray/stray-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/stray/stray-05.jpg',
    ],
  },
  'Stumble Guys': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/stumble-guys/stumble-guys.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/stumble-guys/stumble-guys-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/stumble-guys/stumble-guys-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/stumble-guys/stumble-guys-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/stumble-guys/stumble-guys-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/stumble-guys/stumble-guys-05.jpg',
    ],
  },
  'Tanks Blitz': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/tanks-blitz/tanks-blitz.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/tanks-blitz/tanks-blitz-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/tanks-blitz/tanks-blitz-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/tanks-blitz/tanks-blitz-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/tanks-blitz/tanks-blitz-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/tanks-blitz/tanks-blitz-05.jpg',
    ],
  },
  'Team Fortress 2': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/team-fortress-2/team-fortress-2.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/team-fortress-2/team-fortress-2-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/team-fortress-2/team-fortress-2-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/team-fortress-2/team-fortress-2-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/team-fortress-2/team-fortress-2-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/team-fortress-2/team-fortress-2-05.jpg',
    ],
  },
  'TeamSpeak 3': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/teamspeak-3/teamspeak-3.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/teamspeak-3/teamspeak-3-01.png',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/teamspeak-3/teamspeak-3-02.png',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/teamspeak-3/teamspeak-3-03.png',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/teamspeak-3/teamspeak-3-04.png',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/teamspeak-3/teamspeak-3-05.png',
    ],
  },
  'The Finals': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/the-finals/the-finals.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/the-finals/the-finals-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/the-finals/the-finals-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/the-finals/the-finals-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/the-finals/the-finals-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/the-finals/the-finals-05.jpg',
    ],
  },
  'The Forest': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/the-forest/the-forest.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/the-forest/the-forest-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/the-forest/the-forest-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/the-forest/the-forest-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/the-forest/the-forest-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/the-forest/the-forest-05.jpg',
    ],
  },
  'The Outlast Trials': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/the-outlast-trials/the-outlast-trials.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/the-outlast-trials/the-outlast-trials-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/the-outlast-trials/the-outlast-trials-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/the-outlast-trials/the-outlast-trials-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/the-outlast-trials/the-outlast-trials-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/the-outlast-trials/the-outlast-trials-05.jpg',
    ],
  },
  'The Sims 4': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/the-sims-4/the-sims-4.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/the-sims-4/the-sims-4-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/the-sims-4/the-sims-4-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/the-sims-4/the-sims-4-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/the-sims-4/the-sims-4-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/the-sims-4/the-sims-4-05.jpg',
    ],
  },
  'Tom Clancy’s Rainbow Six Siege': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/tom-clancys-rainbow-six-siege/tom-clancys-rainbow-six-siege.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/tom-clancys-rainbow-six-siege/tom-clancys-rainbow-six-siege-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/tom-clancys-rainbow-six-siege/tom-clancys-rainbow-six-siege-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/tom-clancys-rainbow-six-siege/tom-clancys-rainbow-six-siege-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/tom-clancys-rainbow-six-siege/tom-clancys-rainbow-six-siege-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/tom-clancys-rainbow-six-siege/tom-clancys-rainbow-six-siege-05.jpg',
    ],
  },
  'Ubisoft Connect': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/ubisoft-connect/ubisoft-connect.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/ubisoft-connect/ubisoft-connect-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/ubisoft-connect/ubisoft-connect-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/ubisoft-connect/ubisoft-connect-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/ubisoft-connect/ubisoft-connect-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/ubisoft-connect/ubisoft-connect-05.jpg',
    ],
  },
  Valheim: {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/valheim/valheim.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/valheim/valheim-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/valheim/valheim-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/valheim/valheim-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/valheim/valheim-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/valheim/valheim-05.jpg',
    ],
  },
  'VK Play Игровой центр': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/vk-play-game-center/vk-play-game-center.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/vk-play-game-center/vk-play-game-center-01.png',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/vk-play-game-center/vk-play-game-center-02.png',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/vk-play-game-center/vk-play-game-center-03.png',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/vk-play-game-center/vk-play-game-center-04.png',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/vk-play-game-center/vk-play-game-center-05.png',
    ],
  },
  'War Thunder': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/war-thunder/war-thunder.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/war-thunder/war-thunder-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/war-thunder/war-thunder-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/war-thunder/war-thunder-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/war-thunder/war-thunder-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/war-thunder/war-thunder-05.jpg',
    ],
  },
  'Warcraft III': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/warcraft-iii/warcraft-iii.png',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/warcraft-iii/warcraft-iii-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/warcraft-iii/warcraft-iii-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/warcraft-iii/warcraft-iii-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/warcraft-iii/warcraft-iii-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/warcraft-iii/warcraft-iii-05.jpg',
    ],
  },
  Warface: {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/warface/warface.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/warface/warface-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/warface/warface-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/warface/warface-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/warface/warface-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/warface/warface-05.jpg',
    ],
  },
  Warframe: {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/warframe/warframe.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/warframe/warframe-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/warframe/warframe-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/warframe/warframe-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/warframe/warframe-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/warframe/warframe-05.jpg',
    ],
  },
  'Wargaming.net Game Center': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/wargamingnet-game-center/wargaming-net-game-center.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/wargamingnet-game-center/wargamingnet-game-center-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/wargamingnet-game-center/wargamingnet-game-center-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/wargamingnet-game-center/wargamingnet-game-center-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/wargamingnet-game-center/wargamingnet-game-center-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/wargamingnet-game-center/wargamingnet-game-center-05.jpg',
    ],
  },
  'World of Tanks': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/world-of-tanks/world-of-tanks.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/world-of-tanks/world-of-tanks-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/world-of-tanks/world-of-tanks-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/world-of-tanks/world-of-tanks-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/world-of-tanks/world-of-tanks-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/world-of-tanks/world-of-tanks-05.jpg',
    ],
  },
  'World of Warcraft': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/world-of-warcraft/world-of-warcraft.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/world-of-warcraft/world-of-warcraft-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/world-of-warcraft/world-of-warcraft-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/world-of-warcraft/world-of-warcraft-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/world-of-warcraft/world-of-warcraft-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/world-of-warcraft/world-of-warcraft-05.jpg',
    ],
  },
  'World War Z': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/world-war-z/world-war-z.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/world-war-z/world-war-z-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/world-war-z/world-war-z-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/world-war-z/world-war-z-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/world-war-z/world-war-z-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/world-war-z/world-war-z-05.jpg',
    ],
  },
  'Wuthering Waves': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/wuthering-waves/wuthering-waves.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/wuthering-waves/wuthering-waves-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/wuthering-waves/wuthering-waves-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/wuthering-waves/wuthering-waves-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/wuthering-waves/wuthering-waves-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/wuthering-waves/wuthering-waves-05.jpg',
    ],
  },
  'Zenless Zone Zero': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/zenless-zone-zero/zenless-zone-zero.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/zenless-zone-zero/zenless-zone-zero-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/zenless-zone-zero/zenless-zone-zero-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/zenless-zone-zero/zenless-zone-zero-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/zenless-zone-zero/zenless-zone-zero-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/zenless-zone-zero/zenless-zone-zero-05.jpg',
    ],
  },
  Валорант: {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/valorant/valorant.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/valorant/valorant-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/valorant/valorant-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/valorant/valorant-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/valorant/valorant-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/valorant/valorant-05.jpg',
    ],
  },
  'Казаки 3': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/cossacks-3/cossacks-3.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/cossacks-3/cossacks-3-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/cossacks-3/cossacks-3-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/cossacks-3/cossacks-3-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/cossacks-3/cossacks-3-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/cossacks-3/cossacks-3-05.jpg',
    ],
  },
  Калибр: {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/caliber/caliber.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/caliber/caliber-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/caliber/caliber-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/caliber/caliber-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/caliber/caliber-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/caliber/caliber-05.jpg',
    ],
  },
  'Мир кораблей': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/world-of-warships-ru/world-of-warships-ru.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/world-of-warships-ru/world-of-warships-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/world-of-warships-ru/world-of-warships-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/world-of-warships-ru/world-of-warships-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/world-of-warships-ru/world-of-warships-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/world-of-warships-ru/world-of-warships-05.jpg',
    ],
  },
  'Мир танков': {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/world-of-tanks-ru/world-of-tanks-ru.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/world-of-tanks-ru/world-of-tanks-ru-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/world-of-tanks-ru/world-of-tanks-ru-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/world-of-tanks-ru/world-of-tanks-ru-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/world-of-tanks-ru/world-of-tanks-ru-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/world-of-tanks-ru/world-of-tanks-ru-05.jpg',
    ],
  },
  Террария: {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/terraria/terraria.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/terraria/terraria-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/terraria/terraria-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/terraria/terraria-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/terraria/terraria-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/terraria/terraria-05.jpg',
    ],
  },
  Фортнайт: {
    main_picture:
      'https://storage.yandexcloud.net/smartshell-static/templates/games/covers/fortnite/fortnite.jpg',
    screenshots: [
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/fortnite/fortnite-01.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/fortnite/fortnite-02.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/fortnite/fortnite-03.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/fortnite/fortnite-04.jpg',
      'https://storage.yandexcloud.net/smartshell-static/templates/games/screenshots/fortnite/fortnite-05.jpg',
    ],
  },
};
